module.exports = __webpack_public_path__ + "static/media/icomoon.99efdc5d.svg";